import common_theme_elements from "./common";
import { Components } from "@mui/material";
import RcpTheme, { UI as RcpColors, rcpMuiStyleOverrides } from "./RCP_3.0";
import SymphonyTheme, {
  UI as SymphonyColors,
  symphonyMuiOverrides,
} from "./SYMPHONY_3.2";
import { A2PTheme } from "./theme";

let SelectedTheme = SymphonyTheme;
let UI = SymphonyColors;
let primary = "#BF0000";
let secondary = "#000000";
let themeMuiOverrides = symphonyMuiOverrides;

if (import.meta.env.VITE_THEME === "rcp") {
  SelectedTheme = RcpTheme;
  UI = RcpColors;
  primary = "#90003B";
  secondary = "#36335F";
  themeMuiOverrides = rcpMuiStyleOverrides;
}

const muiStyleOverrrides: Components = {
  MuiCssBaseline: common_theme_elements.MuiCssBaseline,
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundColor: UI.white,
        "&.MuiDialog-paper": {
          verticalAlign: "top",
          marginTop: "64px",
        },
      },
    },
  },
  MuiDivider: {
    styleOverrides: { light: { backgroundColor: primary, height: "3px" } },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        backgroundColor: UI.white,
      },
    },
  },
  //new design have purple text when the input element is focused
  // MuiFormLabel: {
  //   styleOverrides: {
  //     root: {
  //       "&.Mui-focused": {
  //         color: UI.blue_80,
  //       },
  //     },
  //   },
  // },
  MuiInputLabel: {
    styleOverrides: {
      shrink: {
        whiteSpace: "nowrap",
        transform: "translate(0, 1.5px) scale(0.9)",
        color: UI.light_black,
        zIndex: 0,
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: { padding: "0px 10px 0px 16px" },
      footer: { borderBottom: "none" },
    },
  },
  MuiSelect: {
    styleOverrides: {
      icon: {
        color: UI.blue_80,
      },
      iconOpen:{
        color: UI.purple_600,
     }
    },
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        "&$selected": {
          backgroundColor: UI.secondary_hover_rose,
          "&:focus": {
            backgroundColor: UI.secondary_hover_rose,
          },
        },
      },
      button: {
        "&:hover": {
          backgroundColor: UI.white,
        },
        "&$selected": {
          backgroundColor: UI.secondary_hover_rose,
          color: UI.white,
          "&:hover": {
            backgroundColor: UI.secondary_hover_rose,
            color: UI.white,
          },
        },
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        height: "40px",
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        textarea: {
          maxHeight: "114px",
          paddingLeft: "14px",
          paddingTop: "8px",
        },
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        fontWeight: "700",
        "&:hover": {
          backgroundColor: "transparent",
        },
      },
    },
  },
  //@ts-ignore
  MUIDataTableToolbarSelect: {
    styleOverrides: {
      root: {
        height: "auto",
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        color: UI.blue_80,
        background: UI.dark_blue_5,
        borderRadius: "4px 4px 0px 0px",
        textTransform: "none",
      },
      // indicator: { backgroundColor: primary },
      textColorPrimary: {
        color: secondary,
        "&$selected": {
          color: primary,
          background: primary,
          borderRadius: "4px 4px 0px 0px",
        },
        "&$disabled": {
          color: UI.light_black,
        },
      },
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      listbox: {
        backgroundColor: UI.white,
        border: `1px solid ${UI.blue_20}`,
        boxSizing: "border-box",
        borderRadius: "4px",
      },
      option: {
        "&:hover": {
          backgroundColor: UI.blue_20,
          color: UI.blue_80,
        },
      },
    },
  },
  MuiDialog: {
    styleOverrides: { paperWidthLg: { minWidth: "16em" } },
  },
  MuiAccordion: {
    styleOverrides: {
      root: {
        marginBottom: 8,
        border: "1px solid #ccc",
        borderRadius: "4px !important",
      },
    },
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: {
        display: "block",
      },
    },
  },
  // MuiAccordionSummary: {
  //   styleOverrides: {
  //     root: {
  //       minHeight: "unset !important",
  //       borderBottom: "1px solid #ccc",
  //     },
  //     content: {
  //       margin: "0 !important",
  //     },
  //   },
  // },
  MuiTouchRipple: {
    styleOverrides: {
      child: {
        backgroundColor: "white",
      },
    },
  },
  // MuiPickersDateRangePickerToolbarProps: {
  //   styleOverrides: { root: { backgroundColor: secondary } },
  // },
  MUIDataTableToolbar: {
    styleOverrides: {
      root: {
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
        minHeight: 42,
        paddingLeft: "16px",
        paddingRight: "16px",
        // paddingTop:"16px",
        // paddingBottom: "16px",
      },
      actions: {
        display: "flex",
        justifyContent: "flex-end",
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        "&:hover": {
          backgroundColor: "transparent",
        },
      },
    },
  },
  MuiTable: {
    styleOverrides: {
      root: {
        width: "max-content",
        minWidth: "100%",
      },
    },
  },
  MUIDataTableHeadRow: {
    styleOverrides: {
      root: {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: "white",
      },
    },
  },
  MuiLink: {
    styleOverrides: {
      root: {
        textDecoration: "none",
      },
    },
  },
  ...themeMuiOverrides,
};

const theme: A2PTheme = {
  ...SelectedTheme,
  components: muiStyleOverrrides,
};

export default theme;
